import React from 'react';
import Header from './Header';
import Footer from './Footer';
import FloatingWhatsApp from '../FloatingWhatsApp';
import SiteTheme from './SiteTheme';
import { SettingsProvider } from '../../context/SettingsContext';
import './Layout.css';

const Layout = ({ children }) => {
  return (
    <SettingsProvider>
      <SiteTheme />
      <div className="layout">
        <a href="#main-content" className="skip-to-main">
          Skip to main content
        </a>
        <Header />
        <main id="main-content" className="main-content" tabIndex={-1}>
          {children}
        </main>
        <Footer />
        <FloatingWhatsApp />
      </div>
    </SettingsProvider>
  );
};

export default Layout;
